import { render, staticRenderFns } from "./AdminFotoUpload.vue?vue&type=template&id=91a663dc&"
import script from "./AdminFotoUpload.vue?vue&type=script&lang=js&"
export * from "./AdminFotoUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports